import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { ISelectListItem, Log, removeSpaces } from "@ryde/shared";

export const useSelectItemsTranslate = () => {
  const { t, i18n } = useTranslation();

  const translateLabel = useCallback(
    (
      label: string | null | undefined,
      translationPath = "selectListLabel",
    ): string => {
      if (!label) {
        return "";
      }

      const newLabel = removeSpaces(label);
      const translationKey = newLabel?.startsWith(`${translationPath}.`)
        ? newLabel
        : `${translationPath}.${newLabel}`;

      if (i18n.exists(translationKey)) {
        return t(translationKey);
      } else {
        Log.debug("Translation key doesn't exist:", translationKey);
      }

      return label;
    },
    [i18n, t],
  );

  const getTranslatedSelectList = useCallback(
    (
      dropDownItems: ISelectListItem[] | undefined,
      translationPath = "selectListLabel",
    ): ISelectListItem[] => {
      if (!dropDownItems?.length) {
        return [];
      }

      return dropDownItems.map(item => ({
        value: item.value,
        label: translateLabel(item.label, translationPath),
      }));
    },
    [translateLabel],
  );

  return { translateLabel, getTranslatedSelectList };
};
